import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { gluteImages, gluteProduct, heroManifesto } from '../../data/gluteCopy';
export function GluteHero() {
  return <header className="w-full bg-coal text-white" data-id="element-48" data-mp="3mm0rrk4kuvow">
      <div className="mx-auto w-full max-w-6xl px-5 pb-14 pt-10 sm:px-8 sm:pb-20 sm:pt-14 lg:pb-28 lg:pt-20" data-id="element-49" data-mp="3ri817mw6mpbl">
        <div className="mb-10 border-l-4 border-ember pl-5 sm:mb-14 sm:pl-8" data-id="element-50" data-mp="3dql1te6y10ol">
          <p className="text-[2.2rem] font-extrabold uppercase leading-[0.94] tracking-tight text-white sm:text-6xl lg:text-[4.1rem]" data-id="element-51" data-mp="3iiumoft7bak0">
            {heroManifesto.lead}
          </p>

          <p className="mt-4 flex flex-col text-[2.2rem] font-extrabold uppercase leading-[0.94] tracking-tight text-ember sm:mt-6 sm:text-6xl lg:text-[4.1rem]" data-id="element-52" data-mp="38s9uba44f29j">
            {heroManifesto.claims.map(claim => <span key={claim} data-id="element-53" data-mp="2yu3uqz5se87u">{claim}</span>)}
          </p>

          <p className="mt-5 max-w-2xl text-[1.02rem] leading-relaxed text-white/60 sm:mt-7 sm:text-lg" data-id="element-54" data-mp="2ytkahbsnz7qn">
            {heroManifesto.bridge}
          </p>
        </div>

        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20" data-id="element-55" data-mp="365y3zpt0v052">
          <div data-id="element-56" data-mp="3l4ifhtw2voa2">
            <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-57" data-mp="3l2xjs0y11zam">
              Método de 21 días
            </p>

            <h1 className="mt-5 text-[2.2rem] font-extrabold uppercase leading-[0.94] tracking-tight sm:text-6xl lg:text-[4.1rem]" data-id="element-58" data-mp="3g3b2ngf2vywj">
              Glute Lab
              <span className="mt-1 block text-ember" data-id="element-59" data-mp="2nht2kozu7r9f">El Código del Crecimiento</span>
            </h1>

            <p className="mt-6 max-w-lg text-[1.02rem] leading-relaxed text-white/60 sm:text-lg" data-id="element-60" data-mp="326xnwf1xiblr">
              El Protocolo <span className="font-semibold text-white" data-id="element-61" data-mp="2xdcxp96kulx4">“Unlock”</span> neuromuscular:
              pre-activación y pausas isométricas que obligan a tu sistema nervioso a despertar el
              glúteo que tu entrenamiento actual está ignorando.
            </p>

            <div className="mt-8 flex flex-col items-stretch gap-3 sm:mt-10 sm:flex-row sm:items-center sm:gap-5" data-id="element-62" data-mp="2ud31pu4sm24b">
              <CtaButton tone="ember" label="Quiero el método" scrollToId="precio-glute" data-id="element-63" data-mp="2yeerbzno2nci" />
              <p className="text-center text-sm text-white/50 sm:text-left" data-id="element-64" data-mp="337r5tgymtdrj">
                Precio de lanzamiento{' '}
                <span className="font-semibold text-white" data-id="element-65" data-mp="384rbhqrkkei4">
                  ${gluteProduct.guidePrice.toFixed(2)}
                </span>{' '}
                · pago único
              </p>
            </div>

            <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[0.8rem] text-white/40 sm:mt-10 sm:justify-start sm:text-sm" data-id="element-66" data-mp="2fiy5l8az8jr4">
              <li className="inline-flex items-center gap-2" data-id="element-67" data-mp="2pfkss3qrzmwb">
                <DownloadIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-68" data-mp="2pcos47njmk46" />
                Acceso inmediato
              </li>
              <li className="inline-flex items-center gap-2" data-id="element-69" data-mp="4oar6na01mgb">
                <LockIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-70" data-mp="4qn8qzbuhusu" />
                Pago seguro
              </li>
            </ul>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="order-first lg:order-none" data-id="element-71" data-mp="1k8t9uxgsai27">
            <img src={gluteImages.training} alt="Entrenamiento de glúteo en un gimnasio boutique con iluminación cálida" className="aspect-[4/5] w-full rounded-2xl object-cover sm:aspect-[3/2] lg:aspect-[4/5]" width={1200} height={800} data-id="element-72" data-mp="16gwln4i8ksb3" />
          </motion.div>
        </div>
      </div>
    </header>;
}